import { Geotab } from "@fairfleet/geotab";
import { useMutation, useQueryClient } from "@tanstack/react-query";

async function addOrUpdateAddinApplication(groupData: {
  geotabClient: Geotab;
  name: string;
  url: string;
  method: string;
  id?: string;
}) {
  const { geotabClient, name, url, method, id } = groupData;

  const result = await geotabClient.call(method, {
    typeName: "AddIn",
    entity: {
      ...(!id && {
        configuration: {
          name: "Fairfleet Services - " + name,
          supportEmail: "support@fairfleet.de",
          version: "3.0",
          items: [
            {
              url: "https://fairfleet.github.io/ecoapp-addin/" + url,
              path: "GettingStartedLink",
              category: "ProductivityId",
              menuName: {
                de: "Fairfleet " + name,
                en: "Fairfleet " + name,
              },
              icon: "https://fairfleet.github.io/ecoapp-addin/icon.svg",
              menuId: "Fairfleet Services",
            },
          ],
          isSigned: false,
          enableViewSecurityId: true,
        },
      }),
      ...(id && { id }),
    },
  });
  return result;
}

export function useCreateOrUpdateAddInApplication() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addOrUpdateAddinApplication,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["addInApplications"],
      });
    },
  });
}
